module.exports = __webpack_public_path__ + "static/media/2_pl.70e365af.png";